import { ProviderCompletedRegistrationStepsEnum } from '../../api';

export const registrationStepLinks = {
  [ProviderCompletedRegistrationStepsEnum.BASIC_INFO]: '/register/profile',
  [ProviderCompletedRegistrationStepsEnum.RATES]: '/register/profile/rates',
  [ProviderCompletedRegistrationStepsEnum.PROFESSIONAL_TRAITS]:
    '/register/profile/professional-traits',
  [ProviderCompletedRegistrationStepsEnum.LICENSES]: '/register/profile/licenses',
  [ProviderCompletedRegistrationStepsEnum.SIGN_AGREEMENT]: '/register/profile/agreement',
};
